/*
    File Serves the utility functions for problem set page
 */
import * as xlsx from 'xlsx';

export const handleDownload = async ( dataArray, filePath ) => {
    
      const wb = xlsx.utils.book_new();
      
      // Prepare the data to be written to the Excel sheet
      const sheetData = [];

      // Push the header row
      sheetData.push([
        'Problem ID', 
        'Problem Name', 
        'Users Who Solved (Emails)', 
        'Rating', 
        'Original Tags', 
        'Normalized Tags', 
        'Editorials'
      ]);

      // Process each problem and add it to the sheet data
      dataArray.forEach(problem => {
        // Extract user emails
        const userEmails = problem.usersWhoSolved.map(user => user.email).join(', ');

        // Extract original tags and normalized tags
        const originalTags = problem.originalTags.join(', ');
        const normalizedTags = problem.normalizedTag.map(tag => tag.label).join(', ');

        // Extract editorials
        const editorials = problem.editorial.join(', ');

        // Push the problem data as a new row
        sheetData.push([
          problem.problemId,
          problem.problemName,
          userEmails,
          problem.rating,
          originalTags,
          normalizedTags,
          editorials
        ]);
      });

      // Create a worksheet from the data
      const ws = xlsx.utils.aoa_to_sheet(sheetData);

      // Append the worksheet to the workbook
      xlsx.utils.book_append_sheet(wb, ws, 'Problems');

      // Write the workbook to a file
      xlsx.writeFile(wb, filePath);

};